module.exports = __webpack_public_path__ + "static/img/monitor_content_bg2.9761ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/monitor_content_bg2.png
// module id = jD2P
// module chunks = 1